<template>
  <q-form ref="form" class="full-width">
    <div class="row items-center">
      <div class="col-12 col-sm-6 q-px-sm">
        <q-input
          hint
          v-model="formData.devices_id"
          label="Hub ID"
          readonly
        ></q-input>
      </div>
      <div class="col-12 col-sm-6 q-px-sm">
        <q-input hint v-model="formData.pos" label="Position"></q-input>
      </div>
      <div class="col-12 q-px-sm">
        <q-input
          hint
          v-model="formData.descriptor"
          label="Descriptor"
        ></q-input>
      </div>
    </div>
    <div v-if="formData.id" class="row items-center">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">
          Devices
          <div class="float-right">
            <assignDevice
              style="width: 200px; display: inline-block"
              class="q-ml-sm"
              :id="newDevice.devices_id"
              @changed="(val) => (newDevice.devices_id = val)"
            />

            <q-btn
              class="q-ml-md q-mt-md"
              color="secondary"
              text-color="accent"
              unelevated
              no-caps
              @click="addDeviceToChain"
              :loading="addDeviceLoading"
              :disable="newDevice.devices_id == null"
            >
              <q-icon
                name="mdi-plus-circle"
                color="accent"
                class="q-mr-sm"
                size="xs"
              ></q-icon>
              Add
            </q-btn>
          </div>
        </h6>
      </div>
      <div
        v-if="formData.id"
        class="col-12 mt-0 pt-0"
        style="height: calc(100vh - 660px) !important"
      >
        <datatable
          ref="dataTable"
          :filter="search"
          :flat="true"
          :data="devices"
          :columns="columns"
        >
          <template slot="body-cell-pos" slot-scope="data">
            <q-td :props="data.props">
              <q-input
                v-model="data.props.row.pos"
                dense
                type="number"
                style="width: 50px"
                @blur="saveDevice(data.props.row)"
              >
              </q-input>
            </q-td>
          </template>
          <template slot="body-cell-actions" slot-scope="data">
            <q-td :props="data.props">
              <q-btn
                :loading="deletingDeviceFromChain == data.props.row.id"
                @click="removeDeviceFromChain(data.props.row.id)"
                round
                flat
                color="negative"
              >
                <q-icon name="mdi-delete"></q-icon>
              </q-btn>
            </q-td>
          </template>
        </datatable>
      </div>
    </div>
    <div class="row items-center q-pt-md">
      <div class="col-12">
        <q-btn
          v-if="formData.id"
          @click="save()"
          :loading="saveLoading"
          color="primary"
          no-caps
          class="float-right"
        >
          <q-icon
            name="mdi-content-save"
            color="white"
            class="q-mr-sm"
            size="xs"
          ></q-icon>
          Save
        </q-btn>
        <q-btn
          v-else
          @click="create()"
          :loading="createLoading"
          color="primary"
          no-caps
          class="float-right"
        >
          <q-icon
            name="mdi-plus-circle"
            color="white"
            class="q-mr-sm"
            size="xs"
          ></q-icon>
          Create
        </q-btn>
      </div>
    </div>
  </q-form>
</template>

<script>
  import { mapGetters } from "vuex";
  import datatable from "@/components/datatable/datatable.vue";
  import assignDevice from "@/components/devices/assignDevice.vue";

  export default {
    components: { assignDevice, datatable },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        siteData: "settings/siteData",
        devices: "devices/hubChainDeviceList",
        devicesLoading: "devices/hubChainDeviceListLoading",
      }),
    },
    props: {
      data: {
        type: Object,
        default: null,
      },
    },
    watch: {
      data: function () {
        this.init();
      },
    },
    data: () => ({
      // Extra Data
      formData: {},
      saveLoading: false,
      createLoading: false,

      // Devices
      search: "",
      columns: [
        {
          name: "devices_id",
          label: "Device ID",
          align: "left",
          field: "devices_id",
          sortable: true,
        },
        {
          name: "pos",
          label: "Chain Position",
          align: "left",
          field: "pos",
          sortable: true,
        },
        {
          name: "actions",
          label: "Actions",
          align: "left",
          sortable: true,
        },
      ],
      newDevice: {
        devices_id: null,
      },
      addDeviceLoading: false,
      deletingDeviceFromChain: null,
    }),
    mounted() {
      setTimeout(() => {
        this.init();
      }, 100);
    },
    methods: {
      init() {
        if (this.data != null) {
          this.formData = JSON.parse(JSON.stringify(this.data));
          this.$store.dispatch("devices/loadHubChainDevices", this.formData.id);
        } else {
          this.formData = {};
        }
      },
      create() {
        this.createLoading = true;

        this.$store
          .dispatch("devices/newHubChain", this.formData)
          .then((result) => {
            this.createLoading = false;
            if (result.Result == "Success") {
              this.$emit("close", true);
              this.formData = {};
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: result.Response.Message,
              });
            }
          });
      },
      save() {
        this.saveLoading = true;
        setTimeout(() => {
          this.$store
            .dispatch("devices/saveHubChain", this.formData)
            .then((result) => {
              this.saveLoading = false;
              if (result.Result == "Success") {
                // this.$emit("close", true);
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message,
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: result.Response.Message,
                });
              }
            });
        });
      },
      addDeviceToChain() {
        this.addDeviceLoading = true;
        this.newDevice.hubChains_id = this.formData.id;
        this.newDevice.pos = this.devices.length;
        setTimeout(() => {
          this.$store
            .dispatch("devices/addDeviceToChain", this.newDevice)
            .then((result) => {
              this.addDeviceLoading = false;
              if (result.Result == "Success") {
                // this.$emit("close", true);
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message,
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: result.Response.Message,
                });
              }
            });
        });
      },
      saveDevice(data) {
        this.$store.dispatch("devices/saveChainDevice", data).then((result) => {
          this.addDeviceLoading = false;
          if (result.Result == "Success") {
            // this.$emit("close", true);
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: result.Response.Message,
            });
          }
        });
      },
      removeDeviceFromChain(id) {
        this.$swal({
          title: "Warning",
          text: "You are about to remove the device from this chain, Do you wish to continue?",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then((res) => {
          if (res.value) {
            this.deletingDeviceFromChain = id;
            this.$store
              .dispatch("devices/removeDeviceFromChain", {
                id: id,
                hubChains_id: this.formData.id,
              })
              .then((result) => {
                this.deletingDeviceFromChain = null;
                if (result.Result == "Success") {
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: result.Response.Message,
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: "There was an Error, Please try again later",
                  });
                }
              });
          }
        });
      },
    },
  };
</script>
